<template>
    <div>
        <div class="w-1200 nav">
            <img src="../../assets/home_1.png">
            <span class="margin-left-8">{{ nowNav }}</span>
        </div>
        <div class="w-1200 news-body-content">
            <div class="new-left-nav">
                <ul>
                    <li
                            :class="nowNavListValue===item?'new-left-nav-act':''"
                            v-for="(item,index) in newsLeftList"
                            @click="chooseNewsLeft(item)"
                    >
                        {{ item }}
                    </li>
                </ul>
            </div>
            <div class="news-content" id="news-content" v-loading="loading">
                <div class="nonews">
                    <el-link v-if="commonData.length===0" type="danger" disabled>暂时没有相关内容！</el-link>
                </div>
                <ul>
                    <li v-for="(item,index) in commonData" @click="goarticle(item.id)">
                        <span class="text">
                          <el-link>{{ item.title }}</el-link>
                        </span>
                        <span class="time">【{{ item.publish_time }}】</span>
                    </li>
                </ul>
                <div class="pagination" v-if="commonData.length>0">
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="commonDataLength"
                            @current-change="changepage"
                            :page-size="15"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '../../model/api'

    export default {
        name: 'index',
        components: {},
        props: {},
        data () {
            return {
                params: {},
                commonData: [],
                total: 0,
                commonDataLength: 0,
                page: 1,
                lines: 15,
                nowNavListValue: '', // 现在处于哪个目录下
                newsLeftList: [],
                newsrightList: [
                    {
                        nav: [
                            '图片',
                            '视频',
                            '音频',
                        ],
                        img: '',
                        description: [
                            '嫦娥四号着陆器、玉兔二号月....',
                            '京雄城国际安特大桥跨廊珠高...'
                        ]
                    },
                    {
                        nav: [
                            '人物',
                            '故事',
                            '文化',
                        ],
                        img: '',
                        description: []
                    },
                ],
                loading: true
            }
        },
        watch: {},
        computed: {
            nowNav () {
                return '首页' + ' > ' + this.nowNavListValue
            }
        },
        methods: {
            changepage (val) {
                console.log(val)
            },
            goarticle (id) {
                this.$router.push({name: 'art', query: {id: id}}); // 跳到文章详情
            },
            chooseNewsLeft (val) {
                this.nowNavListValue = val;
                this.loading = true;
                this.getListData();
                // setTimeout(() => {
                //     this.loading = false
                // }, 1000)
            },
            getListData () {
                let vars = {};
                vars.params = {
                    sec: this.nowNavListValue,
                    page: this.page,
                    count: this.lines,
                    status: '已发布'
                };
                api.webget(vars, this, data => {
                    console.log(data)
                    setTimeout(() => {
                        this.loading = false
                    }, 1000)
                    this.commonDataLength = data.data.total;
                    this.commonData = data.data.records;
                    this.commonData.map(item => {
                        if (item.content.length > 33) {
                            item.content = item.content.substr(0,33);
                        }
                        item.publish_time = item.publish_time.substr(5,5);
                    })
                });
            }
        },
        created () {
        },
        mounted () {
            this.newsLeftList = api.common.navData[8].leftchild;
            this.nowNavListValue = api.common.navData[8].leftchild[0];
            if (this.$route.query.index) {
                this.nowNavListValue = api.common.navData[8].leftchild[this.$route.query.index];
                this.getListData();
            } else {
                this.getListData();
            }
        }
    }
</script>

<style scoped>
    .nav {
        display: flex;
        flex-direction: row;
        height: 20px;
        align-items: center;
        margin-top: 15px;
    }

    .news-body-content {
        margin-top: 16px;
        display: flex;
        flex-direction: row;
    }

    .new-left-nav {
        width: 200px;
        background: rgba(238, 238, 238, 1);
        border: 1px solid rgba(238, 238, 238, 1);
        height: 861px;
    }

    .new-left-nav ul li {
        width: 199px;
        height: 46px;
        line-height: 46px;
        position: relative;
        cursor: pointer;
    }

    .new-left-nav ul li:hover {
        background: rgba(255, 255, 255, 1);
        font-size: 16px;
        /*font-family: MicrosoftYaHei-Bold;*/
        font-weight: bold;
        color: rgba(182, 11, 13, 1);
    }

    .new-left-nav ul li:hover::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 3px;
        height: 46px;
        background: rgba(182, 11, 13, 1);
    }

    .new-left-nav-act {
        background: rgba(255, 255, 255, 1);
        font-size: 16px;
        /*font-family: MicrosoftYaHei-Bold;*/
        font-weight: bold;
        color: rgba(182, 11, 13, 1);
    }

    .new-left-nav-act::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 3px;
        height: 46px;
        background: rgba(182, 11, 13, 1);
    }

    .news-content {
        width: 982px;
        margin-left: 18px;
    }

    .news-content .text {
        font-size: 16px;
        /*font-family: MicrosoftYaHei;*/
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
    }

    .news-content .time {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(123, 123, 123, 1);
        line-height: 20px;
    }

    .news-content ul li {
        height: 43px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px dashed rgba(220, 220, 220, 1);
        cursor: pointer;
    }

    .news-right {
        width: 314px;
        background: rgba(246, 246, 246, 1);
        margin-left: 28px;
    }

    .news-right-li {
        border-top: 2px solid rgba(182, 11, 13, 1);
        margin-top: 30px;
    }

    .news-right-li:first-child {
        margin-top: 0;
    }

    .news-right-img {
        width: 266px;
        height: 168px;
        background-color: darkgray;
        margin-left: 24px;
        margin-top: 19px;
    }

    .news-right-nav ul {
        display: flex;
        flex-direction: row;
        margin-top: 19px;
    }

    .news-right-nav ul li {
        padding-left: 20px;
        padding-right: 20px;
        border-right: 2px solid rgba(191, 197, 210, 1);
        font-size: 22px;
        /*font-family: MicrosoftYaHei;*/
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
    }

    .news-right-nav-act {
        color: rgba(182, 11, 13, 1) !important;
        font-size: 22px;
        /*font-family: MicrosoftYaHei;*/
        font-weight: 400;
    }

    .news-right-nav ul li:last-child {
        border-right: 0;
    }

    .news-right-description {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-left: 24px;
        margin-top: 12px;
    }

    .news-right-description span {
        margin-top: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/associationservice/associationservice.vue